import { ConditionEvaluatorInterface, ParsedCondition } from "../types";

export class CartEvaluator implements ConditionEvaluatorInterface {
  readonly type = "cart" as const;
  private controllers: Set<AbortController> = new Set();

  watch(condition: ParsedCondition, callback: () => void): () => void {
    if (condition.value !== "has-items" && condition.value !== "empty") {
      console.warn(`Unsupported cart condition value: ${condition.value}`);
      return () => {};
    }

    const controller = new AbortController();
    this.controllers.add(controller);

    fetch("/cart.js", { signal: controller.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch cart: ${response.status}`);
        }
        return response.json() as Promise<{ items?: unknown[] }>;
      })
      .then((data) => {
        if (controller.signal.aborted) return;
        const hasItems = !!data.items && data.items.length > 0;
        if (condition.value === "has-items" && hasItems) {
          callback();
        } else if (condition.value === "empty" && !hasItems) {
          callback();
        }
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        console.error(`Cart condition evaluation failed:`, error);
      })
      .finally(() => {
        this.controllers.delete(controller);
      });

    return () => {
      controller.abort();
      this.controllers.delete(controller);
    };
  }

  dispose(): void {
    this.controllers.forEach((controller) => {
      controller.abort();
    });
    this.controllers.clear();
  }
}
